import React from 'react';

import { NoItemView } from '../NoItemView';
import { IBLSpinLoader } from '../IBLSpinLoader';
import { SkillSlider } from '../SkillSlider';

interface SkillSectionProps {
  title: string;
  skillsData: any[];
  skillsDataLoaded: boolean;
  refreshSkills: (skills: any[]) => void;
  searchTerm: string;
  noSkillsMessage: string;
}

export const SkillSection: React.FC<SkillSectionProps> = ({
  title,
  skillsData,
  skillsDataLoaded,
  refreshSkills,
  searchTerm,
  noSkillsMessage,
}) => {
  return (
    <div className="sk_cont">
      <div className="div-block-483">
        <div className="text-block-278">{title}</div>
      </div>
      {skillsDataLoaded ? (
        skillsData.length > 0 ? (
          <SkillSlider
            skills={skillsData}
            refreshSkills={refreshSkills}
            searchTerm={searchTerm}
          />
        ) : (
          <NoItemView
            displayMessage={noSkillsMessage}
            imageUrl={'/images/tools.png'}
            displayPadding={true}
          />
        )
      ) : (
        <IBLSpinLoader size={40} containerHeight={'200px'} />
      )}
    </div>
  );
};
